import { useInfiniteQuery } from '@tanstack/react-query';
import { container } from '@src/container';
import { SearchPublicPascosUseCase } from '@src/application/pascos/usecases';

export interface SearchPublicPascosParams {
    query: string;
    universityId?: string;
    semester?: string;
    academicYear?: string;
    skip?: number;
    limit?: number;
}

export const useSearchPublicPascos = (params: SearchPublicPascosParams) => {
    const searchPublicPascosUseCase = container.resolve<SearchPublicPascosUseCase>('SearchPublicPascosUseCase');

    return useInfiniteQuery({
        queryKey: ['pascos', 'search', params],
        queryFn: async ({ pageParam = 0 }) => {
            const skip = pageParam * (params.limit || 20);
            return searchPublicPascosUseCase.execute(
                params.query,
                params.universityId,
                params.semester,
                params.academicYear,
                skip,
                params.limit || 20
            );
        },
        getNextPageParam: (lastPage, allPages) => {
            return lastPage.hasMore ? allPages.length : undefined;
        },
        initialPageParam: 0,
        enabled: params.query.trim().length > 0, // Only run query if search term exists
    });
};
